/* Publish by EComposer at 2024-07-15 19:09:23*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fwnlydj72kf"]=  window.__ectimmers["ecom-fwnlydj72kf"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fwnlydj72kf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwnlydj72kf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4mpsrfxpmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4mpsrfxpmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b52kzm8nfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b52kzm8nfg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4fxmc4u94r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4fxmc4u94r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3khbhpwaxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3khbhpwaxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2s635r47cb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2s635r47cb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1ahwqppr3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1ahwqppr3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tn3y3ghesmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tn3y3ghesmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v411qyoxvn7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v411qyoxvn7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sf5mkg2l9y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sf5mkg2l9y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l33s4kljv3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l33s4kljv3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwanxdve64i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwanxdve64i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xtqm4p87f5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xtqm4p87f5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ptb7t8ocpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ptb7t8ocpw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1o0s9ztgv3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1o0s9ztgv3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llx4ty93vac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llx4ty93vac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ukmmofokrp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ukmmofokrp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zahq2dljzoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zahq2dljzoi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckp162z86zp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckp162z86zp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lhnx4t6zwx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lhnx4t6zwx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36py9bdtg1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36py9bdtg1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gg6af6fqatc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gg6af6fqatc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6ut2jhs797').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6ut2jhs797', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gx71dlx0dml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gx71dlx0dml', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-knmh8i615n"]=  window.__ectimmers["ecom-knmh8i615n"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-knmh8i615n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-knmh8i615n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1rp8wtb758').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1rp8wtb758', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbke02jef5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbke02jef5i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sizemffhqnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sizemffhqnm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vt077pwoyyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vt077pwoyyp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lo5184pjjtl"]=  window.__ectimmers["ecom-lo5184pjjtl"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-lo5184pjjtl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lo5184pjjtl', settings: {"source":"hosted"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}